import { ChevronRight, Loader2 } from 'lucide-react';

import type { AuthTenant } from '@/entities/auth';
import { HintIcon } from '@/shared/ui';

import { AUTH_HINT } from '../texts';

/** Выбор компании, когда почта заведена в нескольких. */
export function TenantList({
  tenants,
  onSelect,
  pendingTenantId,
}: {
  tenants: AuthTenant[];
  onSelect: (tenant: AuthTenant) => void;
  /** Компания, по которой уже идёт запрос: у неё лоадер, остальные заблокированы. */
  pendingTenantId?: string | null;
}) {
  const busy = Boolean(pendingTenantId);

  return (
    <div className="grid gap-3">
      <div className="flex items-center gap-1.5 text-sm font-medium text-slate-600">
        Компании
        <HintIcon text={AUTH_HINT.tenants} />
      </div>

      <ul className="grid gap-2">
        {tenants.map((tenant) => (
          <li key={tenant.tenant_id}>
            <button
              type="button"
              disabled={busy}
              onClick={() => onSelect(tenant)}
              className="flex w-full items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 text-left text-[15px] font-medium text-slate-900 transition-colors hover:border-[var(--primary)]/40 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <span className="min-w-0 truncate">{tenant.name}</span>
              {pendingTenantId === tenant.tenant_id ? (
                <Loader2 className="h-4 w-4 shrink-0 animate-spin text-slate-400" />
              ) : (
                <ChevronRight className="h-4 w-4 shrink-0 text-slate-400" />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
